<script lang="ts" setup>
import FilterSidebarPrinter from '~/components/filters/FilterSidebarPrinter.vue'
import BasicInput from '~/components/form-elements/BasicInput.vue'
import BasicInputDecorator from '~/components/form-elements/BasicInputDecorator.vue'
import { CategoryType } from '~/enums/category-type'
import { debounce } from '~/helpers/debounce-helper'
import { createCategoriesStore } from '~/store/categories'
import { shouldShowCategories } from '~/store/compositions/utils/should-show-categories'

const bodyCategoriesStore = createCategoriesStore('bodyCats')()
const {
  getBodySystemCategories,
  isDataLoading: isBodyIngredientCategoriesLoading
} = storeToRefs(bodyCategoriesStore)

const shouldShowBodyCategories = shouldShowCategories(bodyCategoriesStore)

const debouncedBodyCategories = debounce(async (signal: AbortSignal) => {
  bodyCategoriesStore.clearCategories()
  await bodyCategoriesStore.fetchCategories(signal)
}, 300)

async function initFetchMoreCategories (): Promise<void> {
  bodyCategoriesStore.page.number++

  await bodyCategoriesStore.fetchCategories()
}

watch(
  () => bodyCategoriesStore.filter.query,
  () => {
    bodyCategoriesStore.page.number = 1
    debouncedBodyCategories()
  }
)

onMounted (async (): Promise<void> => {
  bodyCategoriesStore.page.size = 5

  bodyCategoriesStore.filter.typeIds = [CategoryType.BodySystem]

  await bodyCategoriesStore.fetchCategories()
})
</script>

<template>
  <div class="flex h-[calc(100vh-180px-max(15vh,72px))] flex-col md:h-full">
    <BasicInputDecorator class="md:mb-2">
      <BasicInput
        v-model="bodyCategoriesStore.filter.query"
        :is-border="false"
        placeholder="Искать по списку"
      />
    </BasicInputDecorator>

    <div class="custom-scroll flex flex-1 flex-col items-center overflow-y-auto md:items-start">
      <FilterSidebarPrinter :categories-data="getBodySystemCategories" />

      <LoadMoreLink
        v-if="shouldShowBodyCategories"
        class="p-3"
        :is-loading="isBodyIngredientCategoriesLoading"
        @click.prevent="initFetchMoreCategories"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'assets/css/custom-scroll';
</style>
